// Plan management models mirroring the Care API plans DTOs
// (GET/POST/PUT/DELETE /api/plans — Platform Owner only).

import { Plan } from "./SubscriptionModels";

export interface PlanFeatureInput {
  featureKey: string;
  featureValue: string;
}

export interface CreatePlanRequest {
  code: string;
  name: string;
  description?: string | null;
  priceMonthly: number;
  currency: string;
  billingPeriodDays: number;
  isActive: boolean;
  isPublic: boolean;
  sortOrder: number;
  features?: PlanFeatureInput[];
}

// Partial update — only provided fields are changed. When `features` is sent,
// ALL existing features are deleted and replaced with the new list.
export type UpdatePlanRequest = Partial<CreatePlanRequest>;

export const KNOWN_FEATURE_KEYS = [
  "messaging_enabled",
  "monthly_message_limit",
  "max_branches",
  "website_enabled",
] as const;

export type PlanEditorValues = Omit<
  CreatePlanRequest,
  "features" | "description"
> & {
  description: string;
  features: PlanFeatureInput[];
};

export const toCreatePlanRequest = (
  values: PlanEditorValues,
): CreatePlanRequest => ({
  ...values,
  description: values.description?.trim() || null,
  features: values.features.filter(
    (f) => f.featureKey.trim() && f.featureValue.trim(),
  ),
});

export const fromPlanToEditorValues = (plan: Plan): PlanEditorValues => ({
  code: plan.code,
  name: plan.name,
  description: plan.description ?? "",
  priceMonthly: plan.priceMonthly,
  currency: plan.currency || "BDT",
  billingPeriodDays: plan.billingPeriodDays || 30,
  isActive: plan.isActive,
  isPublic: plan.isPublic,
  sortOrder: plan.sortOrder,
  features: (plan.features ?? []).map((f) => ({
    featureKey: f.featureKey,
    featureValue: f.featureValue,
  })),
});